import { render, staticRenderFns } from "./Slice.vue?vue&type=template&id=f80e9016"
import script from "./Slice.vue?vue&type=script&lang=js"
export * from "./Slice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports